import React from 'react';
import classnames from 'classnames';
import defaultImage from 'assets/images/search/blurred-facility-placeholder.webp';
import oonImage from 'assets/images/search/blurred-oon-facility-placeholder.webp';

import ImageNotAvailable from './ImageNotAvailable';
import './FacilityImageNotAvailable.scss';

function FacilityImageNotAvailable(props) {
	const enhancedProps = {
		...props,
		className: classnames(props.className, 'facility-image-not-available', {
			oon: props.isOON,
		}),
		defaultImage: props.isOON ? oonImage : defaultImage,
		imageText:
			props.imageText ||
			(props.isOON ? 'No facility image' : 'Image coming soon'),
	};
	return <ImageNotAvailable {...enhancedProps} />;
}

export default FacilityImageNotAvailable;
